// Sparks-related constants and URLs
export const SPARKS_TWITTER_IMAGE_URL = "https://static.classdojo.com/sparks/sparky_twitter.png";
/** Dojo Sparks lockup artwork (1200x630) used for link previews. */
export const SPARKS_OPENGRAPH_IMAGE_URL = "https://static.classdojo.com/sparks/opengraph.png";
